import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { MensagemService } from 'src/app/service/mensagem.service';
import { EstadoCidadeService } from 'src/app/service/estado-cidade.service';
import { Helper } from 'src/app/shared/Helper';

interface CidadeTela {
  cidadeId: string;
  codigoCidade: string;
  nome: string;
  ativo: boolean;
}

interface EstadoTela {
  estadoId: string;
  codigoEstado: string;
  nome: string;
  ativo: boolean;
}

interface ModalEdicao {
  aberto: boolean;
  tipo: 'estado' | 'cidade' | null;
  modo: 'novo' | 'editar';
  titulo: string;
  codigo: string;
  nome: string;
  ativo: boolean;
  id: string;
  salvando: boolean;
}

@Component({
  selector: 'app-estado-cidade',
  templateUrl: './estado-cidade.component.html',
  styleUrls: ['./estado-cidade.component.css']
})
export class EstadoCidadeComponent implements OnInit {

  public estados: EstadoTela[] = [];
  public cidades: CidadeTela[] = [];

  public carregandoEstados = false;
  public carregandoCidades = false;

  public filtroEstado = '';
  public statusEstado = 'todos';
  public paginaEstado = 1;
  public tamanhoPaginaEstado = 20;
  public totalEstados = 0;

  public filtroCidade = '';
  public statusCidade = 'todos';
  public paginaCidade = 1;
  public tamanhoPaginaCidade = 20;
  public totalCidades = 0;

  public estadoSelecionado: EstadoTela = null;

  public modalEdicao: ModalEdicao = {
    aberto: false,
    tipo: null,
    modo: 'novo',
    titulo: '',
    codigo: '',
    nome: '',
    ativo: true,
    id: null,
    salvando: false
  };

  constructor(
    private estadoCidadeService: EstadoCidadeService,
    private msg: MensagemService,
    private router: Router
  ) { }

  ngOnInit() {
    this.carregarEstados();
  }

  public goToHome() {
    Helper.NavToDashboard(this.router, 'Leads');
  }

  public carregarEstados() {
    this.carregandoEstados = true;

    this.estadoCidadeService
      .ListarEstados(this.filtroEstado, this.statusEstado, this.paginaEstado, this.tamanhoPaginaEstado)
      .subscribe((retorno: any) => {
        this.carregandoEstados = false;

        if (!retorno || retorno.sucesso === false) {
          this.msg.Error(retorno && retorno.msg ? retorno.msg : 'Erro ao carregar estados.');
          return;
        }

        this.estados = retorno.itens || [];
        this.totalEstados = retorno.total || 0;

        if (this.estadoSelecionado) {
          const estadoAtualizado = this.estados.find(e => e.estadoId === this.estadoSelecionado.estadoId);
          if (estadoAtualizado) {
            this.estadoSelecionado = estadoAtualizado;
          }
        }
      }, () => {
        this.carregandoEstados = false;
        this.msg.Error('Erro ao carregar estados.');
      });
  }

  public novoEstado() {
    this.abrirModalEstado();
  }

  public editarEstado(estado: EstadoTela) {
    if (!estado || !estado.estadoId) {
      return;
    }

    this.abrirModalEstado(estado);
  }

  public excluirEstado(estado: EstadoTela) {
    if (!estado || !estado.estadoId) {
      return;
    }

    if (!confirm('Deseja realmente excluir o estado ' + estado.nome + ' e suas cidades?')) {
      return;
    }

    this.estadoCidadeService.ExcluirEstado(estado.estadoId).subscribe((retorno: any) => {
      if (!retorno || retorno.sucesso === false) {
        this.msg.Error(retorno && retorno.msg ? retorno.msg : 'Não foi possível excluir o estado.');
        return;
      }

      this.msg.Sucesso(retorno.msg || 'Estado excluído com sucesso.');

      if (this.estadoSelecionado && this.estadoSelecionado.estadoId === estado.estadoId) {
        this.estadoSelecionado = null;
        this.cidades = [];
        this.totalCidades = 0;
      }

      this.paginaEstado = 1;
      this.carregarEstados();
    }, () => {
      this.msg.Error('Não foi possível excluir o estado.');
    });
  }

  public filtrarEstados() {
    this.paginaEstado = 1;
    this.carregarEstados();
  }

  public limparFiltroEstados() {
    this.filtroEstado = '';
    this.statusEstado = 'todos';
    this.paginaEstado = 1;
    this.carregarEstados();
  }

  public proximaPaginaEstados() {
    if (!this.temProximaPaginaEstados()) {
      return;
    }

    this.paginaEstado += 1;
    this.carregarEstados();
  }

  public paginaAnteriorEstados() {
    if (this.paginaEstado <= 1) {
      return;
    }

    this.paginaEstado -= 1;
    this.carregarEstados();
  }

  public temProximaPaginaEstados() {
    return this.paginaEstado * this.tamanhoPaginaEstado < this.totalEstados;
  }

  public selecionarEstado(estado: EstadoTela) {
    this.estadoSelecionado = estado;
    this.paginaCidade = 1;
    this.filtroCidade = '';
    this.statusCidade = 'todos';
    this.carregarCidades();
  }

  public carregarCidades() {
    if (!this.estadoSelecionado || !this.estadoSelecionado.estadoId) {
      this.cidades = [];
      this.totalCidades = 0;
      return;
    }

    this.carregandoCidades = true;

    this.estadoCidadeService
      .ListarCidades(this.estadoSelecionado.estadoId, this.filtroCidade, this.statusCidade, this.paginaCidade, this.tamanhoPaginaCidade)
      .subscribe((retorno: any) => {
        this.carregandoCidades = false;

        if (!retorno || retorno.sucesso === false) {
          this.msg.Error(retorno && retorno.msg ? retorno.msg : 'Erro ao carregar cidades.');
          return;
        }

        this.cidades = retorno.itens || [];
        this.totalCidades = retorno.total || 0;

        if (retorno.estado) {
          this.estadoSelecionado.ativo = retorno.estado.ativo;
          this.estadoSelecionado.nome = retorno.estado.nome;
          this.estadoSelecionado.codigoEstado = retorno.estado.codigoEstado;
        }
      }, () => {
        this.carregandoCidades = false;
        this.msg.Error('Erro ao carregar cidades.');
      });
  }

  public novaCidade() {
    if (!this.estadoSelecionado || !this.estadoSelecionado.estadoId) {
      return;
    }

    this.abrirModalCidade();
  }

  public editarCidade(cidade: CidadeTela) {
    if (!cidade || !cidade.cidadeId || !this.estadoSelecionado) {
      return;
    }

    this.abrirModalCidade(cidade);
  }

  public excluirCidade(cidade: CidadeTela) {
    if (!cidade || !cidade.cidadeId) {
      return;
    }

    if (!confirm('Deseja realmente excluir a cidade ' + cidade.nome + '?')) {
      return;
    }

    this.estadoCidadeService.ExcluirCidade(cidade.cidadeId).subscribe((retorno: any) => {
      if (!retorno || retorno.sucesso === false) {
        this.msg.Error(retorno && retorno.msg ? retorno.msg : 'Não foi possível excluir a cidade.');
        return;
      }

      this.msg.Sucesso(retorno.msg || 'Cidade excluída com sucesso.');
      this.paginaCidade = 1;
      this.carregarCidades();
    }, () => {
      this.msg.Error('Não foi possível excluir a cidade.');
    });
  }

  public filtrarCidades() {
    this.paginaCidade = 1;
    this.carregarCidades();
  }

  public limparFiltroCidades() {
    this.filtroCidade = '';
    this.statusCidade = 'todos';
    this.paginaCidade = 1;
    this.carregarCidades();
  }

  public proximaPaginaCidades() {
    if (!this.temProximaPaginaCidades()) {
      return;
    }

    this.paginaCidade += 1;
    this.carregarCidades();
  }

  public paginaAnteriorCidades() {
    if (this.paginaCidade <= 1) {
      return;
    }

    this.paginaCidade -= 1;
    this.carregarCidades();
  }

  public temProximaPaginaCidades() {
    return this.paginaCidade * this.tamanhoPaginaCidade < this.totalCidades;
  }

  public alternarEstado(estado: EstadoTela) {
    if (!estado || !estado.estadoId) {
      return;
    }

    const acao = estado.ativo ? 'desativar' : 'ativar';
    if (!confirm('Deseja realmente ' + acao + ' o estado ' + estado.nome + '?')) {
      return;
    }

    this.estadoCidadeService.ToggleEstado(estado.estadoId).subscribe((retorno: any) => {
      if (!retorno || retorno.sucesso === false) {
        this.msg.Error(retorno && retorno.msg ? retorno.msg : 'Não foi possível alterar o status do estado.');
        return;
      }

      estado.ativo = retorno.estadoAtivo;
      this.msg.Sucesso(retorno.msg || 'Status do estado atualizado com sucesso.');

      if (this.estadoSelecionado && this.estadoSelecionado.estadoId === estado.estadoId) {
        this.estadoSelecionado.ativo = estado.ativo;
        this.carregarCidades();
      }
    }, () => {
      this.msg.Error('Não foi possível alterar o status do estado.');
    });
  }

  public alternarCidade(cidade: CidadeTela) {
    if (!cidade || !cidade.cidadeId) {
      return;
    }

    const acao = cidade.ativo ? 'desativar' : 'ativar';
    if (!confirm('Deseja realmente ' + acao + ' a cidade ' + cidade.nome + '?')) {
      return;
    }

    this.estadoCidadeService.ToggleCidade(cidade.cidadeId).subscribe((retorno: any) => {
      if (!retorno || retorno.sucesso === false) {
        this.msg.Error(retorno && retorno.msg ? retorno.msg : 'Não foi possível alterar o status da cidade.');
        return;
      }

      cidade.ativo = retorno.cidadeAtiva;
      if (this.estadoSelecionado && retorno.estadoAtivo !== undefined) {
        this.estadoSelecionado.ativo = retorno.estadoAtivo;
      }

      this.msg.Sucesso(retorno.msg || 'Status da cidade atualizado com sucesso.');
    }, () => {
      this.msg.Error('Não foi possível alterar o status da cidade.');
    });
  }

  public fecharModalEdicao() {
    if (this.modalEdicao.salvando) {
      return;
    }

    this.modalEdicao.aberto = false;
  }

  public salvarModalEdicao() {
    if (this.modalEdicao.salvando) {
      return;
    }

    const nome = (this.modalEdicao.nome || '').trim();
    if (!nome) {
      this.msg.Error('O nome é obrigatório.');
      return;
    }

    if (this.modalEdicao.tipo === 'estado') {
      this.salvarEstado(nome);
      return;
    }

    if (this.modalEdicao.tipo === 'cidade') {
      this.salvarCidade(nome);
    }
  }

  private abrirModalEstado(estado?: EstadoTela) {
    const editando = !!(estado && estado.estadoId);

    this.modalEdicao = {
      aberto: true,
      tipo: 'estado',
      modo: editando ? 'editar' : 'novo',
      titulo: editando ? 'Editar estado' : 'Novo estado',
      codigo: editando ? (estado.codigoEstado || '') : 'Gerado automaticamente',
      nome: editando ? (estado.nome || '') : '',
      ativo: editando ? !!estado.ativo : true,
      id: editando ? estado.estadoId : null,
      salvando: false
    };
  }

  private abrirModalCidade(cidade?: CidadeTela) {
    const editando = !!(cidade && cidade.cidadeId);

    this.modalEdicao = {
      aberto: true,
      tipo: 'cidade',
      modo: editando ? 'editar' : 'novo',
      titulo: editando ? 'Editar cidade' : 'Nova cidade',
      codigo: editando ? (cidade.codigoCidade || '') : 'Gerado automaticamente',
      nome: editando ? (cidade.nome || '') : '',
      ativo: editando ? !!cidade.ativo : true,
      id: editando ? cidade.cidadeId : null,
      salvando: false
    };
  }

  private salvarEstado(nome: string) {
    const editando = this.modalEdicao.modo === 'editar';
    const codigoEstado = editando ? this.modalEdicao.codigo : this.gerarCodigo('EST');
    const payload: any = {
      codigoEstado,
      nome,
      ativo: this.modalEdicao.ativo
    };

    this.modalEdicao.salvando = true;

    const operacao = editando
      ? this.estadoCidadeService.EditarEstado(this.modalEdicao.id, payload)
      : this.estadoCidadeService.CriarEstado(payload);

    operacao.subscribe((retorno: any) => {
      this.modalEdicao.salvando = false;

      if (!retorno || retorno.sucesso === false) {
        this.msg.Error(retorno && retorno.msg ? retorno.msg : 'Não foi possível salvar o estado.');
        return;
      }

      this.msg.Sucesso(retorno.msg || (editando ? 'Estado alterado com sucesso.' : 'Estado inserido com sucesso.'));
      this.modalEdicao.aberto = false;

      if (!editando) {
        this.paginaEstado = 1;
      }

      this.carregarEstados();

      if (editando && this.estadoSelecionado && this.estadoSelecionado.estadoId === this.modalEdicao.id) {
        this.carregarCidades();
      }
    }, () => {
      this.modalEdicao.salvando = false;
      this.msg.Error('Não foi possível salvar o estado.');
    });
  }

  private salvarCidade(nome: string) {
    if (!this.estadoSelecionado || !this.estadoSelecionado.estadoId) {
      this.msg.Error('Selecione um estado para salvar a cidade.');
      return;
    }

    const editando = this.modalEdicao.modo === 'editar';
    const codigoCidade = editando ? this.modalEdicao.codigo : this.gerarCodigo('CID');
    const payload: any = {
      estadoFk: this.estadoSelecionado.estadoId,
      codigoCidade,
      nome,
      ativo: this.modalEdicao.ativo
    };

    this.modalEdicao.salvando = true;

    const operacao = editando
      ? this.estadoCidadeService.EditarCidade(this.modalEdicao.id, payload)
      : this.estadoCidadeService.CriarCidade(this.estadoSelecionado.estadoId, payload);

    operacao.subscribe((retorno: any) => {
      this.modalEdicao.salvando = false;

      if (!retorno || retorno.sucesso === false) {
        this.msg.Error(retorno && retorno.msg ? retorno.msg : 'Não foi possível salvar a cidade.');
        return;
      }

      this.msg.Sucesso(retorno.msg || (editando ? 'Cidade alterada com sucesso.' : 'Cidade inserida com sucesso.'));
      this.modalEdicao.aberto = false;

      if (!editando) {
        this.paginaCidade = 1;
      }

      this.carregarCidades();
    }, () => {
      this.modalEdicao.salvando = false;
      this.msg.Error('Não foi possível salvar a cidade.');
    });
  }

  private gerarCodigo(prefixo: string) {
    const data = new Date();
    const base = [
      data.getFullYear(),
      ('0' + (data.getMonth() + 1)).slice(-2),
      ('0' + data.getDate()).slice(-2),
      ('0' + data.getHours()).slice(-2),
      ('0' + data.getMinutes()).slice(-2),
      ('0' + data.getSeconds()).slice(-2),
      ('00' + data.getMilliseconds()).slice(-3)
    ].join('');

    return prefixo + '-' + base;
  }
}
